/**
 * Created by jumesa on 28/12/2015.
 */
jQuery(document).ready(function() {
    // Handler for .ready() called.
    //var priceAmount =  jQuery('.single-product-info .price-box .amount').text();//Mandala
  	jQuery('#product_price').addClass('d-none');
 	jQuery('#AddToCart').addClass('d-none');
  	jQuery('.w3-product-options').addClass('d-none');
    initTools();
  	setListeners();
    
});
function initTools(){
	
  var children = $('.w3-product-options').children().length;
  if ($('.w3-product-options').hasClass('loaded') && children >= 0){
    	var priceAmount =  jQuery(priceSelector).text();//Shopify
        productPrice = accounting.unformat(priceAmount,",");
        if(productPrice == "")
        {
          priceSelector = '.price-container .current-price';
          priceAmount = jQuery(priceSelector).text();
          productPrice = accounting.unformat(priceAmount,",");

        }
        jQuery('#product_price').prepend('<span id="glasses">Montura: </span>');
        jQuery(priceSelector).append('<div class="alert alert-light" role="alert" style="margin-bottom:0px;padding: 0.15rem 1.25rem;"><div id="additionsTotals">Adiciones: $0</div></div>');
        jQuery(priceSelector).append('<div class="alert alert-light" role="alert" style="margin-bottom:0px;padding: 0.15rem 1.25rem;"><div id="priceTotals">Total: '+productPrice+'</div></div>');

        //initToolTips();
        updatePrice();
        if(children == 0)
        {
          jQuery('#product_price #glasses').addClass('d-none');
          jQuery('#product_price span.price div.alert').addClass('d-none');
        }
    	jQuery('#product_price').removeClass('d-none');
        jQuery('.quantity-submit-row').removeClass('d-none');
        jQuery('.w3-product-options').removeClass('d-none');
        jQuery('#AddToCart').removeClass('d-none');
        jQuery('#loading-icon').addClass('d-none');
        //setVariantToolTip();
        if($('.clickyboxes li a.active').hasClass('unavailable')){
              $('.w3-product-options').addClass('d-none');
              $('.soldOutForm').removeClass('d-none');
              $('.htoForm').addClass('d-none');
          }
    }
    else{
      setTimeout(initTools, 500);
    }
  
  	
  
}
function setListeners(){
    jQuery(document).on("change",".product-options-control",function () {
        updatePrice();
      	//setTimeout(initToolTips,500);
    });
  	jQuery('#clickyboxes-option-color li a').on('click',function (){
      if($(this).hasClass('unavailable')){
        $('.w3-product-options').addClass('d-none');
        $('.soldOutForm').removeClass('d-none');
        $('.htoForm').addClass('d-none');
      }
      else{
        $('.w3-product-options').removeClass('d-none');
        $('.soldOutForm').addClass('d-none');
        $('.htoForm').removeClass('d-none');
      }
      setTimeout(initTools, 500);
    });
}
function updatePrice(){
    var price = 0;
   	var additions = 0;
    jQuery('input[type="radio"].product-options-radiobutton').each(function () {
        additions += (this.checked && !this.disabled && data.hasOwnProperty(jQuery(this).val())? data[jQuery(this).val()].price : 0);//setPrice(this,price);
    });
    jQuery('input[type="checkbox"].product-options-checkbox').each(function () {
        additions += (this.checked && !this.disabled && data.hasOwnProperty(jQuery(this).val())? data[jQuery(this).val()].price : 0);//setPrice(this,price);
    });
    price = additions + productPrice;
    //jQuery('.special-price .amount').html(accounting.formatMoney(price, "$", 0, ".", ",")); //Mandala
    jQuery('#additionsTotals').html('Adiciones: '+ accounting.formatMoney(additions, "$", 0, ".", ","));//Shopify
  	jQuery('#priceTotals').html('Total: '+ accounting.formatMoney(price, "$", 0, ".", ","));//Shopify
    var children = $('.w3-product-options').children().length;
    if(children >= 0 && (jQuery('#product_price #glasses').hasClass('d-none')|| jQuery('#product_price span.price div.alert').hasClass('d-none')))
    {
      jQuery('#product_price #glasses').removeClass('d-none');
      jQuery('#product_price span.price div.alert').removeClass('d-none');
    }
}
function initToolTips(){
  
    jQuery('input[type="radio"].product-options-radiobutton').each(function () {
        setTooltip(this);
    });
    jQuery('input[type="checkbox"].product-options-checkbox').each(function () {
        setTooltip(this);
    });
  
    jQuery('[data-toggle="tooltip"]').tooltip();
  
}
function setTooltip(input){
  
  var tooltip =jQuery(input).next().next().data('toggle');
  
  if(!jQuery(input).next().next().data('toggle')){
    var sThisVal = jQuery(input).val();
    var txt,htmlTxt = "";
    if(data.hasOwnProperty(sThisVal)){
        txt = data[sThisVal].text;
      htmlTxt = '<span href="#" data-toggle="tooltip" title="'+txt+'" class="tooltip-container"><img src="https://cdn.shopify.com/s/files/1/1107/6754/files/ic_question_mark.png?10347518171387488469" width="24"></span>';
        jQuery(input).next().after(htmlTxt);
    }
  }
    
}

function fieldAddedCallback(field, element) {
  
  $(element).children('input[type="radio"].product-options-radiobutton').each(function(i) { 
    setTooltip(this);
  });
  $(element).children('input[type="checkbox"].product-options-checkbox').each(function(i) { 
    setTooltip(this);
  });
  
//   $(element).children('[data-toggle="tooltip"]').tooltip();
  
  jQuery('[data-toggle="tooltip"]').tooltip();
}

function setVariantToolTip(){
  
	jQuery('.single-option-selector__radio').each(function () {
        var val = $(this).val();
        if($(this).hasClass('disabled')){
          val = val + ": Agotado";
        }
        $(this).next().attr('title',val);
        $(this).next().attr('data-toggle','tooltip');
    });
  
  	jQuery('[data-toggle="tooltip"]').tooltip();
  
}